import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import WebinarProp from '../propTypes/WebinarProp';
import ImageProp from '../propTypes/imageProp';
import translate from '../translate';

function WebinarPlayer({ t, preview, webinar, title, isDone, onClickLessonAsDone }) {
  const [showVideo, setShowVideo] = useState(false);
  useEffect(() => setShowVideo(true), []);

  const handleWebinarClick = () => {
    window.open(webinar.url, '_blank');
  };
  const handleLessonDoneClick = () => {
    onClickLessonAsDone();
  };

  const containerStyle = { width: '100%', height: '100%' };

  const handleStatus = (w, lessonIsDone) => {
    const startDate = moment.utc(w.startDate);
    const endDate = moment.utc(w.startDate + w.duration);
    let status = 'unStarted';
    if (startDate.valueOf() > moment.utc().valueOf()) {
      status = 'unStarted';
    } else if (startDate.valueOf() < moment.utc().valueOf() && moment.utc().valueOf() < endDate.valueOf()) {
      status = 'onGoing';
    } else if (moment.utc().valueOf() > endDate.valueOf()) {
      status = 'finished';
    }
    switch (status) {
      case 'unStarted':
        return (
          <>
            <div className="webinar-description">{t('academy_webinar_unStarted')}</div>
            <div className="webinar-date">{startDate.format('YYYY MMM DD, HH:mm')}</div>
            <button
              type="button"
              className="webinar-button btn m-btn--pill btn-dynamic"
              onClick={handleWebinarClick}
            >
              {t('academy_webinar_join')}
            </button>
          </>
        );
      case 'onGoing':
        return (
          <>
            <div className="webinar-description">{t('academy_webinar_onGoing')}</div>
            <div className="webinar-date">{startDate.format('YYYY MMM DD, HH:mm')}</div>
            <button
              type="button"
              className="webinar-button btn m-btn--pill btn-dynamic"
              onClick={handleWebinarClick}
            >
              {t('academy_webinar_join')}
            </button>
          </>
        );
      case 'finished':
        return (
          <>
            <div className="webinar-description">{t('academy_webinar_finished')}</div>
            <button
              type="button"
              className="webinar-button btn m-btn--pill btn-dynamic"
              onClick={handleLessonDoneClick}
              disabled={lessonIsDone}
            >
              {t('academy_mark_lesson_done')}
            </button>
          </>
        );
      default: return (<></>);
    }
  };

  return (
    <>
      {showVideo ? (
        <div className="webinar-container">
          <img className="webinar-preview" src={preview.url} alt={title} />
          { handleStatus(webinar, isDone) }
        </div>
      ) : (
        <div style={containerStyle} />
      )}
    </>
  );
}

WebinarPlayer.propTypes = {
  t: PropTypes.func.isRequired,
  preview: PropTypes.shape(ImageProp.propType).isRequired,
  webinar: PropTypes.shape(WebinarProp.propType).isRequired,
  title: PropTypes.string,
  isDone: PropTypes.bool,
  onClickLessonAsDone: PropTypes.func,
};

WebinarPlayer.defaultProps = {
  title: '',
  isDone: false,
  onClickLessonAsDone: () => {},
};

export default translate(WebinarPlayer);
